import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import useAgentStore from 'src/hooks/UseStore';
import { clearFingerprintSession } from 'src/utils/fingerprint';
import { useSession } from 'next-auth/react';


const initialAuthState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

const reducer = (state, action) => {
  if (action.type === 'AUTH_STATE_CHANGED') {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    };
  }
  return state;
};

export const AuthContext = createContext({
  ...initialAuthState,
  method: 'FirebaseAuth',
  signInWithEmailAndPassword: () => Promise.resolve(),
  logout: () => Promise.resolve()
});

export const AuthProvider = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialAuthState);
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status === 'authenticated' && session?.user) {
        dispatch({
          type: 'AUTH_STATE_CHANGED',
          payload: {
            isAuthenticated: true,
            user: session.user,
          }
        });
    } else if (status === 'unauthenticated' || status === 'loading') {
        // Handle both unauthenticated and loading states to ensure initialization
        dispatch({
          type: 'AUTH_STATE_CHANGED',
          payload: {
            isAuthenticated: false,
            user: null,
          }
        });
    }
  }, [session, status]);

  return (
    <AuthContext.Provider value={{ ...state, method: 'FirebaseAuth' }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const AuthConsumer = AuthContext.Consumer;
